import { ProfileManagementInterface } from "@/components/profile/ProfileManagementInterface";

export const ManagedTimelinesTab = () => {
  return (
    <div>
      <ProfileManagementInterface />
    </div>
  );
};